import { render, staticRenderFns } from "./QuestionModalCardPending.vue?vue&type=template&id=3374f1c9&"
import script from "./QuestionModalCardPending.vue?vue&type=script&lang=js&"
export * from "./QuestionModalCardPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports